<template>
    <div class="col-md-12 mt-3">
        <div class="card shadow-sm p-4">
            <h4 class="text-center mb-3">{{$store.getters.t('admin_accountant_expenditure_requests_title')}}</h4>

            <div class="row mb-3">
                <div class="col-md-4">
                    <input type="text" class="text-field" v-model="keyword" :placeholder="$store.getters.t('admin_accountant_expenditure_search')">
                    <label>
                        <input type="checkbox" v-model="filterByID">
                        {{$store.getters.t('admin_accountant_expenditure_filter_by_id')}}
                    </label>
                </div>
                <div class="col-md-8 text-center d-flex justify-content-center align-items-center">
                    <span class="badge badge-sm badge-success cursor-pointer" @click="setExpenditureRequestsFilter('view', 'accountant')">{{$store.getters.t('admin_accountant_expenditure_approved_and_partially_paid')}}</span>
                    <span class="badge badge-sm badge-warning cursor-pointer" @click="setExpenditureRequestsFilter('view', 'moderate')">{{$store.getters.t('admin_accountant_expenditure_on_moderation')}}</span>
                    <span class="badge badge-sm badge-light cursor-pointer" @click="setExpenditureRequestsFilter('status', 'processed')">{{$store.getters.t('admin_accountant_expenditure_fully_paid')}}</span>
                    <span class="badge badge-sm badge-secondary cursor-pointer" @click="setExpenditureRequestsFilter('view', 'all')">{{$store.getters.t('admin_accountant_expenditure_all')}}</span>
                </div>
            </div>
            <vuetable ref="vuetable" api-url="/admin/api/expenditure-requests" :fields="fields" @vuetable:pagination-data="onPaginationData"
                      data-path="data" pagination-path="meta" :show-sort-icons="true" :css="css.table" :append-params="additionalQueryParams"
                      :sort-params="getSortParam"
            >

                <div slot="images" slot-scope="{rowData}">

                    <span class="attached_images" v-for="file in rowData.images">
                        <a :href="`/storage${file.path}`" target="_blank">
                            <img :src="`/storage${file.path.replace('original', 'avatar')}`" alt="">
                        </a>
                    </span>

                </div>

                <div slot="amount" slot-scope="{rowData}">

                    {{rowData.currency.code}} {{rowData.amount}}

                </div>

                <div slot="already_funded" slot-scope="{rowData}">

                    {{rowData.currency.code}} {{rowData.already_funded}}

                </div>

                <div slot="deficit" slot-scope="{rowData}">

                    {{rowData.currency.code}} {{rowData.deficit}}

                </div>

                <div slot="purpose" slot-scope="{rowData}">

                    {{rowData.purpose}}

                    <template v-if="rowData.ticket_url">
                        <br><a arget="_blank" :href="`${rowData.ticket_url}`">{{$store.getters.t('admin_accountant_expenditure_ticket')}}</a>
                    </template>

                </div>

                <div slot="link" slot-scope="{rowData}">

                    <span v-if="rowData.type === 'move_funds_request' && rowData.source_type && rowData.source">
                        <a target="_blank" :href="`/pets/${rowData.source_id}`"
                           v-if="rowData.source_type.indexOf('Pet') >= 0">{{ rowData.source.name || $store.getters.t('admin_accountant_expenditure_no_name') }}</a>

                        <a target="_blank" :href="`/projects/${rowData.source_id}`"
                           v-else-if="rowData.source_type.indexOf('Project') >= 0">
                            {{ rowData.source.name || $store.getters.t('admin_accountant_expenditure_no_name') }}
                        </a>

                        <span v-else>{{rowData.source.source_type}}</span><span>&nbsp;({{ rowData.source.available_funds }} USD {{$store.getters.t('admin_accountant_expenditure_available')}})&nbsp;->&nbsp;</span>
                    </span>
                    <span>
                        <a target="_blank" :href="`/pets/${rowData.target_id}`"
                           v-if="rowData.target_type.indexOf('Pet') >= 0">{{ rowData.target.name  || $store.getters.t('admin_accountant_expenditure_no_name') }}</a>

                        <a target="_blank" :href="`/projects/${rowData.target_id}`"
                           v-else-if="rowData.target_type.indexOf('Project') >= 0">{{ rowData.target.name || $store.getters.t('admin_accountant_expenditure_no_name') }}</a>

                        <span v-else>{{ rowData.target_type }}</span>
                    </span>

                </div>

                <div class="actions" slot="actions" slot-scope="{rowData}">

                    <template v-if="rowData.type === 'move_funds_request'">
                        {{$store.getters.t('admin_accountant_expenditure_moderator_check_required')}}
                    </template>
                    <template v-else>
                        <button class="btn btn-sm btn-success" data-target="#expenditurePageModal" data-toggle="modal"
                                @click.prevent="modalObject = rowData; payForm.currency = rowData.currency.code; payForm.forceApprove = rowData.status !== 'created'">{{$store.getters.t('admin_accountant_expenditure_pay')}}</button>

                        <button v-if="rowData.status === 'created' || rowData.status === 'funded'" class="btn btn-sm btn-dark"
                                @click.prevent="processExpenditureRequest(rowData.id)">{{$store.getters.t('admin_accountant_expenditure_finish')}}</button>

                    </template>

                </div>




            </vuetable>

            <!-- Modal -->
            <div class="modal fade" id="expenditurePageModal" tabindex="-1" role="dialog" aria-labelledby="expenditurePageModal" aria-hidden="true" v-show="modalObject">
                <div class="modal-dialog modal-dialog-centered" role="document" v-if="modalObject">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title">{{modalObject.target.name}}</h5>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body">

                            <div class="row">
                                <div class="col-md-12">
                                    <div class="modal-text">
                                        {{modalObject.purpose}}
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-6">
                                    <div class="modal-text">
                                        {{$store.getters.t('admin_accountant_expenditure_needed')}} <strong>{{modalObject.deficit}} {{modalObject.currency.code}}</strong>
                                    </div>

                                </div>
                                <div class="col-md-6">
                                    <div class="modal-text">
                                        {{$store.getters.t('admin_accountant_expenditure_already_paid')}} <strong>{{modalObject.already_funded}} {{modalObject.currency.code}}</strong>
                                    </div>

                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-12">
                                    <label class="modal-input modal-text">
                                        <div >{{$store.getters.t('admin_accountant_expenditure_enter_amount')}}</div>
                                        <input type="number" class="text-field"  :placeholder="$store.getters.t('admin_accountant_expenditure_enter_amount')" v-model="$v.payForm.amount.$model">
                                        <div class="text-danger text-danger--form" v-if="$v.payForm.amount.$error">{{$store.getters.t('admin_accountant_expenditure_amount_invalid')}}</div>
                                    </label>

                                </div>
                                <div class="col-md-12" v-if="modalObject.status ==='created'">
                                    <label class="modal-input modal-text">
                                        <input type="checkbox" v-model="$v.payForm.forceApprove.$model">
                                        {{$store.getters.t('admin_accountant_expenditure_request_not_moderated_pay_question')}}
                                        <div class="text-danger text-danger--form" v-if="$v.payForm.forceApprove.$error">{{$store.getters.t('admin_accountant_expenditure_must_confirm_payment')}}</div>
                                    </label>
                                </div>

                                <div class="col-md-12" v-if="((+this.modalObject.deficit) < (+payForm.amount))">
                                    <label class="modal-input modal-text">
                                        <input type="checkbox" v-model="$v.payForm.forceFund.$model">
                                        {{$store.getters.t('admin_accountant_expenditure_amount_exceeds_question')}}
                                        <div class="text-danger text-danger--form" v-if="$v.payForm.forceFund.$error">{{$store.getters.t('admin_accountant_expenditure_must_confirm_payment')}}</div>
                                    </label>
                                </div>
                            </div>

                            <div class="form-group">
                                <div class="mb-3">
                                    <div class="row">
                                        <div class="col-12 col-md-12">
                                            <div class="modal-text">{{$store.getters.t('admin_accountant_expenditure_attach_documents')}}</div>
                                        </div>
                                        <div class="col-12 col-md-12">
                                            <div class="modal-text">
                                                <label class="upload" for="screenshot">

                                                    {{$store.getters.t('admin_accountant_expenditure_choose_file')}}

                                                    <input type="file" id="screenshot"
                                                           ref="file" name="photos" class="files w-100" multiple accept=".jpeg, .bmp, .png"
                                                           @change="handleFileUpload">
                                                </label>


                                                <div class="images-block" v-if="previewImages.length">
                                                    <div class="file-wrapp" v-for="(image, index) in previewImages">

                                                        {{image.name}}
                                                        <span class="file-delete"  @click.prevent="deletePhoto(index)" >&times;</span>
                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="modal-footer">
                            <button v-if="reqStatus === 'failed'"
                                    type="button" class="btn btn-danger" data-dismiss="modal">{{$store.getters.t('admin_accountant_expenditure_sent')}} {{payForm.amount}} {{payForm.currency}}</button>

                            <button v-if="reqStatus === 'success'"
                                    type="button" class="btn btn-success" data-dismiss="modal">{{$store.getters.t('admin_accountant_expenditure_sent')}} {{payForm.amount}} {{payForm.currency}}</button>

                            <button v-if="reqStatus === 'waiting_to_send'" type="button" class="btn btn-primary" @click.prevent="fundExpenditureRequest(modalObject.id)"
                                    data-moderation-type="expenditure_requests" :disabled="!payForm.forceApprove || !payForm.forceFund">{{$store.getters.t('admin_accountant_expenditure_send')}} {{payForm.amount}} {{payForm.currency}}</button>

                            <button type="button" class="btn btn-secondary" data-dismiss="modal">{{$store.getters.t('admin_accountant_expenditure_cancel')}}</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>


        <div class="pagination-area mt-3">
            <vuetable-pagination :css="css.pagination" ref="pagination" @vuetable-pagination:change-page="onChangePage"/>
        </div>

    </div>
</template>

<script>

import Vuetable from 'vuetable-2';
import VuetablePagination from 'vuetable-2/src/components/VuetablePagination';
import {required, decimal, minValue, requiredIf} from 'vuelidate/lib/validators';


const initialPayForm = {
    currency: '',
    amount: 0,
    forceApprove: true,
    forceFund: true
};

export default {
    name: "AccountantExpenditure",
    components: { Vuetable, VuetablePagination },
    data(){
        return{
            fields: [

                { name: 'id', title: 'id', titleClass: 'text-left', sortField: 'id' },

                { name: 'type', title: this.$store.getters.t('admin_accountant_expenditure_type'), titleClass: 'text-left', sortField: 'type',
                    formatter: value => {
                        switch (value) {
                            case 'expenses_report':
                                return 'Отчет о расходах';
                            case 'allotment_request':
                                return 'Запрос средств';
                            case 'move_funds_request':
                                return 'Запрос на перевод средств';
                            default:
                                return 'N/A';
                        }
                    }

                },

                { name: 'images', title: this.$store.getters.t('admin_accountant_expenditure_files'), titleClass: 'text-left'},

                { name: 'amount', title: this.$store.getters.t('admin_accountant_expenditure_total_amount'), titleClass: 'text-left', sortField: 'amount'},

                { name: 'already_funded', title: this.$store.getters.t('admin_accountant_expenditure_already_paid_col'), titleClass: 'text-left nowrap'},

                { name: 'deficit', title: this.$store.getters.t('admin_accountant_expenditure_deficit'), titleClass: 'text-left nowrap'},

                { name: 'purpose', title: this.$store.getters.t('admin_accountant_expenditure_purpose'), titleClass: 'text-left'},

                { name: 'link', title: this.$store.getters.t('admin_accountant_expenditure_link'), titleClass: 'text-left'},

                { name: 'status', title: this.$store.getters.t('admin_accountant_expenditure_status'), titleClass: 'text-left', sortField: 'status',
                    formatter: value => {
                        switch (value) {
                            case 'created':
                                return '<span class="badge badge-info">Создан</span>';
                            case 'approved':
                                return '<span class="badge badge-success">Одобрен</span>';
                            case 'funded':
                                return '<span class="badge badge-warning">Оплачен частично</span>';
                            case 'processed':
                                return '<span class="badge badge-success">Полностью оплачен</span>';
                            case 'rejected':
                                return '<span class="badge badge-danger">Отклонен</span>';
                            default:
                                return '<span class="badge badge-light">' + value + '</span>';
                        }
                    }
                },

                { name: 'actions', title: this.$store.getters.t('admin_accountant_expenditure_actions'), titleClass: 'text-center', },


            ],

            css:{

                table: {
                    ascendingIcon: 'icn asc-icn',
                    descendingIcon: 'icn desc-icn',
                    sortableIcon: 'icn sortable-icn',
                },

                pagination:{
                    wrapperClass: 'pagination',
                    linkClass: 'page-numbers',
                    icons: {
                        first: 'first',
                        prev: 'prv',
                        next: 'nxt',
                        last: 'last',
                    },
                },

            },

            previewImagesOnlyBase64: [],
            previewImages: [],
            images: [],

            payForm: {
                currency: '',
                amount: 0,
                forceApprove: true,
                forceFund: true
            },

            reqStatus: 'waiting_to_send',
            reqStatusError: null,
            modalObject: null,

            filterByID: false,
            keyword: null,

            additionalParams: {
                view: 'accountant',
                per_page: 5,
                order_by: null,
                direction: null,
            },

        }
    },

    mounted() {
        const self = this;

        $('#expenditurePageModal').on('hidden.bs.modal', function (e) {
            self.resetModalValues();
            $('input[type=file]').val('');
            self.$v.$reset();
        })

    },

    computed: {
        additionalQueryParams() {

            let params = this.additionalParams;

            return params;

        },
    },

    watch: {

        keyword( _k ) {

            if( ! _k ) {
                this.additionalParams.keyword = null;
                this.additionalParams.id = null;
                this.$refs.vuetable.refresh();
                return
            }

            if( this.filterByID ){
                this.additionalParams.id = _k;
                this.additionalParams.keyword = null;
                this.$refs.vuetable.refresh();
                return;
            }

            if( ! this.filterByID  &&  _k.length  >= 3 ){
                this.additionalParams.keyword = _k;
                this.additionalParams.id = null;
                this.$refs.vuetable.refresh();
            }

        },

        additionalQueryParams(){
            this.$refs.vuetable.refresh();
        },

        'payForm.amount': function(){

            if( ! this.modalObject ) return;

            if ((+this.modalObject.deficit) < +(this.payForm.amount)) {
                this.payForm.forceFund = false;
            }
        },

        images() {
            let self = this;

            if (self.noReloadPreview) {
                self.noReloadPreview = false;
                return false;
            }

            self.images.forEach(function (image) {
                if (typeof FileReader === "function") {
                    const reader = new FileReader();

                    reader.onload = event => {
                        if ($.inArray(event.target.result, self.previewImagesOnlyBase64) === -1) {
                            self.previewImages.push({
                                'base64': event.target.result,
                                'name': image.name,
                            });
                            self.previewImagesOnlyBase64.push(event.target.result);
                        }
                    };

                    reader.readAsDataURL(image);
                }
            });

        },

    },

    methods:{

        getSortParam(sortOrder) {

            if(sortOrder.length) {

                if( this.additionalParams.direction  ===  'desc' && sortOrder[0].direction !== 'desc'  &&  this.additionalParams.order_by  ===  sortOrder[0].sortField ){
                    this.$refs.vuetable.sortOrder.splice(0,1)

                    this.additionalParams.order_by = null;
                    this.additionalParams.direction = null;
                    return
                }

                this.additionalParams.order_by = sortOrder[0].sortField;
                this.additionalParams.direction = sortOrder[0].direction;

            }

        },

        onPaginationData(paginationData) {
            const lastPage = paginationData.last_page,
                currentPage = paginationData.current_page;

            if( +currentPage > +lastPage  ){
                return this.$refs.vuetable.gotoPage(+lastPage);
            }

            this.$refs.pagination.setPaginationData(paginationData);
        },
        onChangePage(page) {
            this.$refs.vuetable.changePage(page)
        },

        setExpenditureRequestsFilter(param, value) {
            let status = null;
            let view = null;
            switch (param) {
                case 'view':
                    view = value
                    break;
                case 'status':
                    status = value
                    break;
            }

            const promise = new Promise( resolve => {
                resolve( this.additionalParams.view = view )
                resolve( this.additionalParams.status = status )
            } )

            promise
                .then( () => { this.$refs.vuetable.refresh() } )
                .catch( ( e ) => { console.log( e ) } )
        },

        b64toBlob(b64Data, contentType, sliceSize) {
            contentType = contentType || '';
            sliceSize = sliceSize || 512;

            let byteCharacters = atob(b64Data);
            let byteArrays = [];

            for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
                let slice = byteCharacters.slice(offset, offset + sliceSize);

                let byteNumbers = new Array(slice.length);
                for (var i = 0; i < slice.length; i++) {
                    byteNumbers[i] = slice.charCodeAt(i);
                }

                let byteArray = new Uint8Array(byteNumbers);

                byteArrays.push(byteArray);
            }

            return new Blob(byteArrays, {type: contentType});
        },
        deletePhoto(index) {
            let self = this;
            self.noReloadPreview = true;
            self.previewImages.splice(index, 1);
            self.images.splice(index, 1);
            self.previewImagesOnlyBase64.splice(index, 1);
        },

        handleFileUpload(e) {

            let self = this;
            let files = e.target.files;
            self.images = [];

            for (let key in files) {

                if (e.target.files[key] instanceof File) {
                    self.images.push(e.target.files[key]);
                }
            }


        },

        async fundExpenditureRequest( _idx ) {

            if (this.payForm.amount === 0) return;

            this.$v.payForm.$touch();

            if (this.$v.payForm.$invalid) {
                return false;
            }
            const self = this,
                prepareData = {
                    expenditure_request_id: _idx,
                    amount: this.payForm.amount,
                    currency: this.payForm.currency,
                };

            if(this.modalObject.status === 'created'){
                prepareData.force_approve = this.payForm.forceApprove ? 1 : 0
            }

            if((+this.modalObject.deficit) < (+this.payForm.amount)){
                prepareData.force_fund = this.payForm.forceFund ? 1 : 0
            }

            let data = new FormData();

            for( const key in prepareData ){
                data.append(`${key}`, prepareData[key])
            }

            if (this.previewImagesOnlyBase64.length) {
                this.previewImagesOnlyBase64.forEach(function (base64) {
                    let block = base64.split(";");
                    let contentType = block[0].split(":")[1];
                    let realData = block[1].split(",")[1];
                    let blob = self.b64toBlob(realData, contentType);
                    data.append('images[]', blob)
                });
            }

            try{

                const { data: { success = false, ...rest } } = await  axios
                    .post( '/admin/api/expenditure-requests/process', data, { headers: { 'Content-Type': 'multipart/form-data' } } );

                if (success) {
                    this.reqStatus = 'success';
                    this.$refs.vuetable.reload();
                }



            } catch ( _e ){

                console.log( _e.response.data.message );

                this.reqStatus = 'failed';
                this.reqStatusError = setTimeout( () => { this.reqStatus = 'waiting_to_send' }, 3000 );

            }


        },

        async processExpenditureRequest( _idx ){

            if(confirm('Подтвердите действие завершения запроса. После подтверждения вы сможете найти его на вкладке "Полностью оплаченные запросы".')){

                let formData = new FormData();

                formData.append('status', 'processed');

                try{

                    const { data: { success = false, ...rest } } = await axios
                        .post( `/admin/api/expenditure-requests/${_idx}?_method=PUT`, formData );

                    if (success) {
                        this.$refs.vuetable.reload();
                    }

                } catch ( _e ) {
                    alert(_e.response.data.message);
                }

            }

        },

        resetModalValues(){
            clearTimeout(this.reqStatusError);

            this.reqStatus = 'waiting_to_send';
            this.payForm = {...initialPayForm};

            this.reqStatusError = null;
            this.modalObject = null;

            this.images = [];
            this.previewImagesOnlyBase64 = [];
            this.previewImages = [];

        },




    },

    validations: {
        payForm: {
            amount: {
                required,
                decimal,
                minValue: minValue(0)
            },

            forceApprove: {
                required,
                custom: function (value) {
                    return value;
                }
            },

            forceFund: {
                required: requiredIf(function (value) {
                    return (+this.modalObject.deficit) < (+this.payForm.amount);
                }),
                custom: function (value) {
                    return value;
                }
            }
        },
    },


}
</script>

<style lang="scss" scoped>
/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
}

/* Firefox */
input[type=number] {
    -moz-appearance: textfield;
}
.file-wrapp{
    display: block;
    background: #007bff;
    color: #fff;
    position: relative;
    font-size: 14px;
    line-height: 18px;
    border-radius: 4px;
    padding: 5px 25px;
    margin-top: 10px;
}

.file-delete{
    position: absolute;
    right: 0;
    top: 0;
    width: 20px;
    height: 20px;
    line-height: 20px;
    text-align: center;
    cursor: pointer;
    background: #3D9BFF;
}

.modal-text{
    display: block;
    margin-bottom: 10px;
    font-size: 14px;
    color: #555;

    .text-danger{
        padding: 0 10px;
        font-weight: 700;
    }

    .upload{
        display: block;
        background: #007bff;
        color: #fff;
        text-align: center;
        position: relative;
        line-height: 25px;
        border-radius: 4px;
        padding: 5px 25px;
        input{
            position: absolute;

            left: 0;
            top: 0;
            opacity: 0;
            z-index: -1;
            visibility: hidden;
        }
    }
}

.text-field{
    background: #f4f5f8;
    border: none;
    line-height: 25px;
    border-radius: 4px;
    padding: 5px 25px;
    margin-bottom: 0;
    height: unset;
    font-size: 15px;
    color: #333;
    width: 100%;
    resize: none;
}

.card .text-field{
    padding: 15px 25px;
}

.upload_cross{
    line-height: 28px;
    vertical-align: -11px;
    width: 28px;
    border-radius: 3px;
    background: rgba(6, 116, 236, 0.1);
    font-size: 14px;
    display: inline-block;
    text-align: center;
    color: #0674ec;
}

.sortable{

    position: relative;

    .sortable-icn{
        content: '↕';
        display: inline-block;
        position: relative;
        font-size: 16px;
    }

}

.pagination-area::v-deep a {
    line-height: 36px;
    display: inline-block;
    min-width: 48px;
    -webkit-transition: 0.3s ease;
    -o-transition: 0.3s ease;
    transition: 0.3s ease;
    background: #fff;
    -webkit-border-radius: 25px;
    margin: 0 2px;
    border-radius: 25px;
    font-weight: 500;
    color: #747b86;
    text-align: center;
    overflow: hidden;
    height: 36px;
    cursor: pointer;
    outline: none;
    outline-offset: 0;

    i{
        display: block;
        position: relative;
        width: 100%;
        height: 100%;
    }

    .first{
        &::before{
            content: '<<';
        }
    }

    .prv{
        &::before{
            content: '<';
        }
    }

    .nxt{
        &::before{
            content: '>';
        }
    }


    .last{

        &:before{
            content: '>>';
        }
    }

    &.active,
    &:hover{

        background: #2e76e4;
        color: #fff;

    }

    &.disabled{
        pointer-events: none;
        cursor: auto;

        &:hover{
            background: #fff;
            color: #747b86;
        }

    }



}

</style>

<style lang="scss">



.preview-doc {
    width: 50px;
    margin-right: 5px;
}

.paginator ul {
    list-style: none;
    padding: inherit;
    margin: 0 auto;
    display: inline-block;


    li {
        padding: 2px 10px;
        background-color: #527bff;
        float: left;
        margin-right: 10px;
        border-radius: 50%;
        color: #fff;

    }
}
.cursor-pointer {
    cursor: pointer;
}

.nowrap,
.actions {
    white-space: nowrap;
}

.attached_images a {
    display: inline-block;
    margin-right: 3px;
    margin-bottom: 3px;

    &:last-child {
        margin-right: 0;
        margin-bottom: 0;
    }

    img {
        max-width: 50px;
        max-height: 50px;
    }
}

</style>
